import {useNavigate, useParams} from "react-router";
import React, {useState} from "react";
import {Link} from "react-router-dom";

// MUI
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Chip from "@mui/material/Chip";
import Alert from "@mui/material/Alert";

// App imports
import RepositoryHomePage from "../repo_details/RepositoryHomePage";
import Login from "../login/Login";

function RepositoryPreviewPage(props) {
    let params = useParams();
    // console.log(params);

    const {id} = params;

    return ( <React.Fragment>
            <div>
                {props.authString
                    ? <MainContent authString={props.authString} id={id} authRole={props.authRole}/>
                    : <Login setAuthString={props.setAuthString} />
                }
                {/*<MainContent authString={props.authString} id={id}/>*/}
            </div>
    </React.Fragment>);
}

const MainContent = (props) => {
    const navigate = useNavigate();
    const [repository, setRepository] = useState();
    const [DataisLoaded, setDataisLoaded] = useState(false);
    const canPublish = props.authRole === 'publisher';

    const [open, setOpen] = React.useState(false);
    const [openApprove, setOpenApprove] = React.useState(false);
    const [actionError, setActionError] = React.useState(null);

    React.useEffect( () => {
        if(!props.authString) {
            console.log("not logged in");
            navigate("/login");
        } else {
            var requestUrl = process.env.REACT_APP_API_BASE_URL + 'admin/repositories/extended/' + props.id;

            fetch(requestUrl, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${props.authString}`
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    setRepository(responseJson);
                    setDataisLoaded(true);
                })
        }
    }, [navigate, props.authString, props.id]);

    const handlePublishOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    }

    const handleApproveOpen = () => {
        setOpenApprove(true);
    }

    const handleApproveClose = () => {
        setOpenApprove(false);
    }

    const handlePublish= () => {
        setOpen(false);
        setActionError(null);

        const requestUrl = process.env.REACT_APP_API_BASE_URL + 'admin/repositories/' + repository.id + '/ready';

        return fetch(requestUrl, {
            mode: 'cors',
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Basic ${props.authString}`
            }),
            body: JSON.stringify(repository)
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                return response.json().then(body => {
                    throw new Error(body?.error || `Server error ${response.status}`);
                }).catch(() => {
                    throw new Error(`Server error ${response.status}`);
                });
            })
            .then(data => {
                setRepository(data);
            })
            .catch((error) => {
                console.error(error);
                setActionError('Failed to mark repository ready for publish: ' + error.message);
            });
    }

    const handleApprove = () => {
        setOpenApprove(false);
        setActionError(null);

        const requestUrl = process.env.REACT_APP_API_BASE_URL + 'admin/repositories/' + repository.id + '/approve';

        return fetch(requestUrl, {
            mode: 'cors',
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Basic ${props.authString}`
            }),
            body: JSON.stringify(repository)
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                return response.json().then(body => {
                    throw new Error(body?.error || `Server error ${response.status}`);
                }).catch(() => {
                    throw new Error(`Server error ${response.status}`);
                });
            })
            .then(data => {
                setRepository(data);
            })
            .catch((error) => {
                console.error(error);
                setActionError('Failed to publish repository: ' + error.message);
            });
    }

    function markReady(repository_id, authString) {
    // console.log(repository_id);
    // console.log("auth string: " + authString);
        const requestUrl = process.env.REACT_APP_API_BASE_URL + 'admin/repositories/' + repository_id + '/review';

        return fetch(requestUrl, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Basic ${authString}`
            })
        })
            .then(data => data.json())
            .then(data => {
                setRepository(data);
            })
    }

    function markPublishReady() {

        console.log("markPublishReady");
        handlePublishOpen();
        // console.log(repository_id);
        // console.log("auth string: " + authString);

    }

    if (DataisLoaded) {
        return (
            <React.Fragment>
                <Box className='repository-preview-wrapper'>
                    <Box className='repository-preview-box'>
                        <div className='repository-management-title'>
                            <span style={{marginLeft: '40px'}}>You are previewing your data repository submission</span>
                            <span style={{marginLeft: '16px'}}>
                                {repository.status === 'Published' &&
                                    <Chip label='Published' size='small' style={{backgroundColor: 'rgba(94, 191, 96, 1)', color: 'white'}} />}
                                {repository.status === 'In Review' &&
                                    <Chip label='In Review' size='small' style={{backgroundColor: 'rgba(186, 144, 59, 1)', color: 'white'}} />}
                                {repository.status === 'Ready for Publish' &&
                                    <Chip label='Ready for Publish' size='small' style={{backgroundColor: 'rgba(186, 144, 59, 1)', color: 'white'}} />}
                                {repository.status === 'Draft' &&
                                    <Chip label='Draft' size='small' style={{backgroundColor: '#737373', color: 'white'}} />}
                                {!repository.status &&
                                    <Chip label='Draft' size='small' style={{backgroundColor: '#737373', color: 'white'}} />}
                            </span>
                            {repository.status === "Published"
                                ? <Typography variant='body2' style={{marginLeft: '40px'}}>
                                    Your edits have been published. You can see the current live repository details below.
                                </Typography>
                                : repository.status === "Draft"
                                ? <Typography variant='body2' style={{marginLeft: '40px'}}>
                                    Please review the repository submission. If there is missing or incorrect information you can select "Edit" to go back to editing the data submission. If everything looks good you can select "Mark Ready for Review" to submit it for administrator review.
                                </Typography>
                                : repository.status === "In Review"
                                ? <Typography variant='body2' style={{marginLeft: '40px'}}>
                                    This repository is currently in review. You can select "Edit" to make updates, or if all information is complete, select "Mark Ready for Publish".
                                </Typography>
                                : repository.status === "Ready for Publish"
                                ? <Typography variant='body2' style={{marginLeft: '40px'}}>
                                    This repository is marked ready for publish. A publisher can either publish it to the live site or send it back to review.
                                </Typography>
                                : <Typography variant='body2' style={{marginLeft: '40px'}}>
                                    Please review the repository submission. If there is missing or incorrect information you can select "Edit" to go back to editing the data submission. If everything looks good you can select "Mark Ready for Review" to submit it for administrator review.
                                </Typography>
                            }
                        </div>

                        {actionError &&
                            <Alert severity="error" onClose={() => setActionError(null)} style={{margin: '12px 0'}}>
                                {actionError}
                            </Alert>
                        }

                        <div style={{marginTop: '25px', height: '35px'}}>
                            <div style={{float: 'right'}}>
                                <Link to={'/repositories/management/edit/' + props.id}>
                                    <Button size="small" variant="contained"
                                            style={{backgroundColor: '#E0A800'}}>Edit</Button>
                                </Link>

                                {repository.status === "In Review" && canPublish
                                    && <Button onClick={(e) => {
                                        markPublishReady(props.id, props.authString)
                                    }} size="small" variant="contained"
                                              style={{marginLeft: '20px', backgroundColor: 'rgb(45, 85, 103)'}}>
                                        Mark Ready for Publish
                                    </Button>
                                }
                                {repository.status === "Draft"
                                    && <Button onClick={(e) => {
                                        markReady(props.id, props.authString)
                                    }} size="small" variant="contained"
                                              style={{marginLeft: '20px', backgroundColor: 'rgb(45, 85, 103)'}}>
                                        Mark Ready for Review
                                    </Button>
                                }

                                {repository.status === "Ready for Publish" && canPublish
                                && <>
                                    <Button onClick={handleApproveOpen} size="small" variant="contained"
                                            style={{marginLeft: '20px', backgroundColor: '#2e7d32'}}>
                                        Publish
                                    </Button>
                                    <Button onClick={(e) => {
                                        markReady(props.id, props.authString)
                                    }} size="small" variant="contained"
                                            style={{marginLeft: '20px', backgroundColor: 'rgb(45, 85, 103)'}}>
                                        Send Back to Review
                                    </Button>
                                </>
                                }

                                {repository.status === "Published" && canPublish
                                && <Button onClick={(e) => {
                                    markReady(props.id, props.authString)
                                }} size="small" variant="contained"
                                          style={{marginLeft: '20px', backgroundColor: 'rgb(45, 85, 103)'}}>
                                    Send Back to Review
                                </Button>
                                }

                                <Link to={'/repositories/management'}>
                                    <Button size="small" variant="contained"
                                            style={{marginLeft: '20px', backgroundColor: 'rgb(45, 85, 103)'}}>Back to
                                        Management Home</Button>
                                </Link>
                            </div>
                        </div>

                        {/*
                            <ReadyToPublishDialog
                            repository={repository}
                            selectedValue={selectedValue}
                            open={open}
                            onClose={handleClose}
                        />*/}
                        <Dialog onClose={handleClose} open={open}>
                            <DialogTitle>Confirm Ready To Publish</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to mark this repository ready to publish?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button id='accept_publish_yes_button' onClick={handleClose} >No</Button>
                                <Button id='accept_publish_no_button' onClick={handlePublish} autoFocus>
                                    Yes
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog onClose={handleApproveClose} open={openApprove}>
                            <DialogTitle>Confirm Publish</DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    Are you sure you want to publish this repository to the live site?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button id='confirm_publish_no_button' onClick={handleApproveClose}>No</Button>
                                <Button id='confirm_publish_yes_button' onClick={handleApprove} autoFocus>
                                    Yes, Publish
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <RepositoryHomePage repository={repository}/>
                    </Box>
                </Box>
            </React.Fragment>
        );
    }
}

export default RepositoryPreviewPage;
